type RowId = Record<string, unknown>;

export function areAllRowsSelected(
  rows: RowId[],
  selectedIds: Set<string>,
  queuedIds: Set<string>,
) {
  const queued = (row: RowId) => queuedIds.has(String(row.id));
  return (
    rows.length > 0 &&
    rows.every((row) => selectedIds.has(String(row.id)) || queued(row)) &&
    rows.some((row) => !queued(row))
  );
}

export function toggleRowsSelection(
  selectedIds: Set<string>,
  rows: RowId[],
  checked: boolean,
  queuedIds: Set<string>,
) {
  const next = new Set(selectedIds);
  rows.forEach((row) => {
    const id = String(row.id);
    if (!checked) next.delete(id);
    else if (!queuedIds.has(id)) next.add(id);
  });
  return next;
}
